import Filter from "./features/Filter";
import Table from "./features/Table";
import {useState} from "react";
import {ExchangeMapType, ExchangeSearchParamType} from "./interface";
import {exchangeMapInit, exchangeSearchParamInit} from "./state";
import {useReadExchangeRate} from "./hooks/useReadExchangeRate";
import {useModal} from "../../../../hooks";
import moment from "moment/moment";

export default function ExchangeDetail() {
    const {handleModal} = useModal();

    const [searchParam, setSearchParam] = useState<ExchangeSearchParamType>((() => ({
        ...exchangeSearchParamInit,
        endAt: moment().format("YYYY-MM-DD"),
        startAt: moment().format("YYYY-MM-DD"),
    }))())

    const {mutateAsync: mutateAsyncReadExchangeRate} = useReadExchangeRate()

    const [exchange, setExchange] = useState<ExchangeMapType>(exchangeMapInit)

    const searchCallback = (param: ExchangeSearchParamType) => {
        mutateAsyncReadExchangeRate(param).then(res => {
            if (res?.data?.code !== "0000") {
                handleModal({
                    isOpen: true,
                    contents: res?.data?.msg,
                    type: "alert",
                });
            } else {
                setExchange(res.data.result ?? exchangeMapInit)
            }
        }).catch(e => {
            if (e?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: e?.response?.data?.msg,
                    type: "alert",
                });
            }
        })
    }

    return <>
        <Filter searchParam={searchParam} setSearchParam={setSearchParam} searchCallback={searchCallback}/>

        <Table exchange={exchange} searchParam={searchParam} setSearchParam={setSearchParam}
               searchCallback={searchCallback}/>
    </>
}